<template>
    <div class='apply-record'>
        <el-table
            v-loading="isFullLoading"
            ref="elTable"
            style="width: 100%"
            :data="applyRecord"
            :height="'calc(100vh - 140px)'"
            :empty-text="isFullLoading ? ' ' : '暂无数据'">
            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>
            <el-table-column
                label="微信信息"
                min-width="280">
                <template v-slot="{ row }">
                    <user-info :userInfo="{
                        avatar: row.avatar,
                        nickname: row.nickname,
                        gender: row.gender
                    }"/>
                </template>
            </el-table-column>
            <el-table-column
                label="真实姓名"
                min-width="180">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.realname }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="phone"
                label="手机号"
                min-width="120">
            </el-table-column>
            <el-table-column
                label="提交时间"
                min-width="120">
                <template v-slot="{ row }">
                    <p>{{ row.create_time.split(' ')[0] }}</p>
                    <p>{{ row.create_time.split(' ')[1] }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                min-width="110">
                <template v-slot="{ row }">
                    <button
                        v-if="row.status === -1"
                        class="text-btn pl-0"
                        @click="addStaffInfo(row)"
                    >通过</button>
                    <span v-if="row.status === 0"
                        class="color-green">已通过</span>
                </template>
            </el-table-column>
            <p v-if="isHasMore && isLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && applyRecord.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
        <!-- components -->
        <edit-and-add-staff-info
            :visible.sync="isShowAddStaff"
            :mode="'create'"
            :applyInfo="curApplyInfo"
            :confirmCallback="applyCallback"/>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, computed, onBeforeMount, onMounted } from '@vue/composition-api'
import EditAndAddStaffInfo from '../modules/edit_and_add_staff_info.vue'
import $fetch from '../../../api'
import { useScrollLoad, openMessage, openRenewMessage } from '../../../utils/system'
import clone from 'lodash/cloneDeep'
import { editionJudge } from '../../../utils/editionJudge'

export default createComponent({
    setup(props, ctx) {
        const isFullLoading = ref(false)
        const isShowAddStaff = ref(false)
        const curApplyInfo = ref<{ [propName: string]: any }>({})
        const applyRecord = ref<any[]>([])
        const staffAmount = ref(0)
        const {
            page: oPage,
            isHasMore,
            isLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const oLimit = 20
        const store = ctx.root.$store

        const curStaffAmount = computed(() => {     // 需要减去超管
            return staffAmount.value - 1
        })

        onBeforeMount(() => {
            console.log(editionJudge)
            isFullLoading.value = true
            getApplyRecord()
                .then(() => isFullLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getApplyRecord
            })
        })

        async function getApplyRecord(page = oPage.value, limit = oLimit) {
            try {
                const result = await $fetch.post({
                    url: '/staff/getstaffapplicationrecords',
                    params: {
                        page,
                        limit
                    }
                })
                console.log('申请记录', clone(result))
                staffAmount.value = result.staff_count
                if (page === 1) {
                    applyRecord.value = result.records
                    initScrollLoad(result)
                } else {
                    applyRecord.value = applyRecord.value.concat(result.records)
                }
                return result
            } catch (e) {
                openMessage('error', e.message || '获取员工申请记录失败')
            }
        }

        function addStaffInfo(row: { [propName: string]: any }) {
            if (!store.getters['shop/canIUse'](6)) {
                return openMessage('error', '暂无添加员工权限，请联系超管开启')
            }
            if (editionJudge.isBiaoZhun && curStaffAmount.value >= 0) {
                return openRenewMessage('标准版不可额外添加员工，如需添加更多员工，请升级为专业版/旗舰版')
            }
            if (editionJudge.isZhuanYe && curStaffAmount.value >= 5) {
                return openRenewMessage('专业版最多添加5位员工（不含超管），如需添加更多员工，请升级为旗舰版')
            }
            if (editionJudge.isQiJian && curStaffAmount.value >= 14) {
                return openMessage('error', '旗舰版最多添加14位员工（不含超管）')
            }
            // curApplyInfo.value = row
            // isShowAddStaff.value = true
            openMessage('info', '请前往零售通添加员工')
        }

        function applyCallback() {
            if (oPage.value === 1) {
                isFullLoading.value = true
                getApplyRecord()
                    .then(() => isFullLoading.value = false)
            } else {
                isFullLoading.value = true
                applyRecord.value = applyRecord.value.slice(0, - oLimit)
                getApplyRecord()
                    .then(() => isFullLoading.value = false)
            }
        }

        return {
            // data
            isHasMore,
            isLoading,
            isFullLoading,
            isShowAddStaff,
            curApplyInfo,
            applyRecord,
            // methods
            addStaffInfo,
            applyCallback
        }
    },
    components: {
        EditAndAddStaffInfo
    }
})
</script>
